/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Apple_StoreInputs */

const en_plan_apple_store = /** @type {(inputs: Plan_Apple_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apple Store`)
};

const es_plan_apple_store = /** @type {(inputs: Plan_Apple_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App Store de Apple`)
};

/**
* | output |
* | --- |
* | "Apple Store" |
*
* @param {Plan_Apple_StoreInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_apple_store = /** @type {((inputs?: Plan_Apple_StoreInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Apple_StoreInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_apple_store(inputs)
	return en_plan_apple_store(inputs)
});